import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { SupplierContractChecksStore } from '../stores/supplier-contract-checks.store';

export const supplierContractChecksStoreSetupGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const store = inject(SupplierContractChecksStore);
  const supplierContractId = route.paramMap.get('supplierContractId')!;
  store.reset();
  store.supplierContractId.set(supplierContractId);
  return true;
};
